export default __webpack_public_path__ + "static/media/orders.3c2a79fa.svg";